
import {getUrlData} from '@/helpers/appUrl.js'
const {appType, assessment} = getUrlData()
export const appInfo = {
  type: appType,
  assessment: assessment,

};
